import styled from "styled-components";

const SubHeading = styled.h2`
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 20px 0;
`;

export default SubHeading;
